import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-top-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [],
    templateUrl: './top-bar.component.html',
    styleUrl: './top-bar.component.scss'
})
export class TopBarComponent {

}
